import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import lang from './modules/lang'
import users from './modules/users'
import utils from './modules/utils'
import layout from './modules/layout'
import entities from './modules/entities'
import dashboards from './modules/dashboards'
import widgetTemplate from './modules/widgetTemplate'
import widgetCreation from '@/store/modules/widgetCreation'
import templatesCategory from './modules/templatesCategory'
import axiosRequestsDuration from './modules/axiosRequestsDuration'
import sound from './modules/sound'

import reportTrigger from '@/modules/reports/store/reportTrigger'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState({
        paths: [
            'users',
            'dashboards.activeDashboard.DashboardID',
            'dashboards.activeDashboard.DashboardLayoutID',
            'dashboards.activeDashboard.DashboardTitle',
            'dashboards.activeDashboard.DashBoardsUserPermission',
            'dashboards.activeDashboard.AccountID',
            'dashboards.editMode',
            'layout'
        ],
    })],
    modules: {
        lang,
        utils,
        users,
        layout,
        entities,
        dashboards,
        widgetTemplate,
        widgetCreation,
        templatesCategory,
        reportTrigger,
        axiosRequestsDuration,
        sound
    }
})
